import { IconButton, Tooltip } from "@mui/material";
import { MoonIcon, SunIcon } from "@phosphor-icons/react"
import useStore from "../../store/useStore";
import { DARK, LIGHT } from "../../enums/themeEnums";

const iconProps = { size: 20, weight: "fill" }

export const ThemeSwitch = () => {
  const { themeMode, setThemeMode } = useStore();

  const handleSwitchThemeMode = () => {
    setThemeMode(themeMode === DARK ? LIGHT : DARK);
  }

  return (
    <Tooltip title={themeMode === DARK ? 'Light Mode' : 'Dark Mode'}>
      <IconButton onClick={() => handleSwitchThemeMode()} color="primary">
        {
          themeMode === DARK ?
            <SunIcon {...iconProps} />
            : <MoonIcon {...iconProps} />
        }
      </IconButton>
    </Tooltip>
  );
}